<template>
  <div class="root">
    <BaseCard
      imageURL="rux-floating.jpg"
      :routerLink="{
        name: 'List',
      }"
    >
      View All My RUX</BaseCard
    >
  </div>
</template>

<script>
import BaseCard from './BaseCard'
export default {
  name: 'ViewAllRux',
  components: { BaseCard },
}
</script>

<style>
</style>